// resetUserMessageViewScope.js
'use strict';
import { ADD_MESSAGES } from '../ActionTypes.js';
import { MESSAGE_PACK_FEED_ALIAS } from '../RemoteConfigKeys.js';

import getMessageIds from '../selector/getMessageIds.js';
import getMessageData from '../selector/getMessageData.js';
import getFeedName from '../selector/getFeedName.js';
import getListData from '../selector/getListData.js';
import getProductData from '../selector/getProductData.js';

import fetchProductDetail from '../action/fetchProductDetail.js';

import { getFeedNameType } from '../resource/feedUtils.js';
import { ProductType } from '../resource/shopConstants.js';

/**
 * Reset multi message's view scope.
 * @kind action
 * @param {string} {userId} - user id.
 * @param {string} {productId} - product id.
 * @return {Promise} Action promise.
 */
const resetUserMessageViewScope =
  ({ userId, productId } = {}) =>
  async (dispatch, getState) => {
    let messageIds = [];
    if (userId) {
      messageIds = (getMessageIds(getState()) || []).filter(messageId => {
        const senderId = getMessageData(getState(), messageId, 'senderId');
        return senderId === userId;
      });
    } else if (productId) {
      if (!getProductData(getState(), [productId], 'type')) {
        await dispatch(fetchProductDetail({ productId }));
      }
      const productType = getProductData(getState(), [productId], 'type');
      switch (productType) {
        case ProductType.MESSAGEPACKS: {
          const feedName = getFeedName(
            getState(),
            MESSAGE_PACK_FEED_ALIAS,
            '{PRODUCT_ID}',
            productId
          );
          messageIds =
            getListData(
              getState(),
              ['home', getFeedNameType({ feedName }), feedName],
              'itemIds'
            ) || [];
        }
      }
    }
    if (messageIds.length) {
      return dispatch({
        type: ADD_MESSAGES,
        payload: {
          messages: messageIds.reduce((accumulator, messageId) => {
            accumulator[messageId] = {
              id: messageId,
              viewScope: null,
            };
            return accumulator;
          }, {}),
        },
      });
    }
    return dispatch({ type: '' });
  };

export default resetUserMessageViewScope;
